///home/clement/compta-app/client/src/components/Reports/Comptables/CompteResultat.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Alert,
  Grid
} from '@mui/material';

const CompteResultat = () => {
  const [compteResultat, setCompteResultat] = useState({ produits: [], charges: [], resultat: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Récupération des données du compte de résultat depuis l'API
  useEffect(() => {
    const fetchCompteResultat = async () => {
      try {
        const response = await axios.get('/api/compte-resultat');
        setCompteResultat(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCompteResultat();
  }, []);

  // Calcul du total des produits et des charges
  const totalProduits = compteResultat.produits.reduce((sum, item) => sum + item.montant, 0);
  const totalCharges = compteResultat.charges.reduce((sum, item) => sum + item.montant, 0);
  const resultatNet = totalProduits - totalCharges;

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">Erreur : {error}</Alert>;

  return (
    <div className="compte-resultat">
      <Typography variant="h4" gutterBottom>
        Compte de Résultat
      </Typography>
      <Grid container spacing={3}>
        {/* Colonnes Produits */}
        <Grid item xs={6}>
          <Typography variant="h6" gutterBottom>
            Produits
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Poste</TableCell>
                  <TableCell>Montant (€)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {compteResultat.produits.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.poste}</TableCell>
                    <TableCell>{item.montant.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell><strong>Total Produits</strong></TableCell>
                  <TableCell><strong>{totalProduits.toFixed(2)}</strong></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {/* Colonnes Charges */}
        <Grid item xs={6}>
          <Typography variant="h6" gutterBottom>
            Charges
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Poste</TableCell>
                  <TableCell>Montant (€)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {compteResultat.charges.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.poste}</TableCell>
                    <TableCell>{item.montant.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell><strong>Total Charges</strong></TableCell>
                  <TableCell><strong>{totalCharges.toFixed(2)}</strong></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      {/* Résultat net */}
      <Typography variant="h6" gutterBottom style={{ marginTop: '20px', color: resultatNet >= 0 ? 'green' : 'red' }}>
        Résultat Net : {resultatNet.toFixed(2)} € {resultatNet >= 0 ? '(Bénéfice)' : '(Perte)'}
      </Typography>
    </div>
  );
};

export default CompteResultat;
